import dayjs from 'dayjs'

/** The JBP actuals-sync date, e.g. for the YTD period label: `05, Jan, 2026`. */
export const formatCockpitActualsDate = (fDateActuals: string) =>
  dayjs(fDateActuals).format('DD MMM YYYY')
